/**
 * Form Configuration Interfaces
 * Framework-agnostic form field definitions
 */

export type FormFieldType =
  | "text"
  | "email"
  | "password"
  | "number"
  | "select"
  | "multiselect"
  | "checkbox"
  | "radio"
  | "date"
  | "datetime"
  | "textarea"
  | "file"
  | "image";

export interface FormFieldOption {
  label: string;
  value: any;
  disabled?: boolean;
}

export interface FormFieldValidation {
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  min?: number;
  max?: number;
  pattern?: string | RegExp;
  email?: boolean;
  custom?: (value: any) => boolean | string;
}

export interface FormField {
  name: string;
  label: string;
  type: FormFieldType;
  placeholder?: string;
  defaultValue?: any;
  value?: any;
  options?: FormFieldOption[];
  validation?: FormFieldValidation;
  disabled?: boolean;
  readonly?: boolean;
  hidden?: boolean;
  description?: string;
  className?: string;
  gridColumn?: string;
}

export interface FormConfig {
  fields: FormField[];
  submitLabel?: string;
  resetLabel?: string;
  className?: string;
  layout?: "vertical" | "horizontal" | "inline";
}
